import MomentUtils from '@date-io/moment'
import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
  LinearProgress,
  MenuItem,
  MenuList,
  makeStyles
} from '@material-ui/core'
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers'
import clsx from 'clsx'
import debounce from 'lodash.debounce'
import moment from 'moment'
import React, { useContext, useEffect, useRef, useState } from 'react'
import RTE from 'react-rte'
import stripHtml from 'string-strip-html'
import uuid from 'uuid'

import ToastMessages from '../../components/ToastMessages'
import { addOrEditMovieTickets, getSearch } from '../../services/ClubeApi'
import { getLoggedUser, isAuthenticated } from '../../services/auth'

import Context from '../../context'
import history from '../../services/history'

import CreateFileS3 from '../../services/CreateFileS3'
import ImageUploadToS3 from '../../services/ImageUpload'

const { REACT_APP_IMAGES_URL, REACT_APP_BUCKET } = process.env

function MovieTicketsForm(props) {
  const { setUser, setAboutCurrentPage, setShowLoadingModal, setOpenToast } = useContext(Context)
  const { itemToEdit } = props.location.state || {}

  const [data, setData] = useState({
    id: itemToEdit?.id,
    partnerId: itemToEdit?.partnerId,
    validDate: itemToEdit?.validDate || moment().add(7, 'days').format('YYYY-MM-DD'),
    fullValue: itemToEdit?.fullValue || 0,
    value: itemToEdit?.value || 0,
    purchasePrice: itemToEdit?.purchasePrice || 0,
    rules: itemToEdit
      ? RTE.createValueFromString(itemToEdit.rules, 'html')
      : RTE.createEmptyValue(),
    room: itemToEdit?.room || '',
    roomType: itemToEdit?.roomType || '',
    movieType: itemToEdit?.movieType || '',
    complement: itemToEdit?.complement || '',
    sunday: itemToEdit?.sunday || 0,
    monday: itemToEdit?.monday || 0,
    tuesday: itemToEdit?.tuesday || 0,
    wednesday: itemToEdit?.wednesday || 0,
    thursday: itemToEdit?.thursday || 0,
    friday: itemToEdit?.friday || 0,
    saturday: itemToEdit?.saturday || 0,
    csv: itemToEdit?.csv || '',
    newCodes: [],
    cover: itemToEdit?.cover || '',
    slug: itemToEdit?.slug || ''
  })

  const [loading, setLoading] = useState(false)
  const [errors, setErrors] = useState(null)
  const [shouldExclude, setShouldExclude] = useState(false)

  const [loadingCSV, setLoadingCSV] = useState(false)
  const [CSV, setCSV] = useState(null)
  const [imageName, setImageName] = useState(null)

  const [partners, setPartners] = useState({
    data: [],
    loading: false,
    query: itemToEdit?.Partner?.fantasyName || '',
    chosen: null,
    showOptions: false
  })

  const [additional, setAdditional] = useState('')

  const searchPartners = useRef(
    debounce(async query => {
      if (query.trim().length < 1) return

      setPartnersInfo({ loading: true })
      const data = await getSearch('partner', query)
      setPartnersInfo({
        data,
        loading: false
      })
    }, 350)
  ).current

  const classes = useStyles()

  useEffect(() => {
    if (!isAuthenticated) return history.replace('/')

    setUser(getLoggedUser)
    setAboutCurrentPage({
      title: itemToEdit ? 'Editar ingressos' : 'Novo grupo de ingressos'
    })

    if (data.csv) getCSV()
  }, [])

  useEffect(() => {
    setAdditional(additional)
  }, [additional])

  useEffect(() => {
    if (itemToEdit?.roomType === 'others') {
      setAdditional('Adicionais')
    }
  }, [])

  const setDataIfPossible = param => {
    !loading && setData(data => ({ ...data, ...param }))
  }

  console.log(data)
  const setPartnersInfo = param => setPartners(partners => ({ ...partners, ...param }))

  const getCSV = async () => {
    try {
      setLoadingCSV(true)
      setShowLoadingModal(true)
      const CSV = await fetch(data.csv).then(res => res.text())
      setCSV(CSV.split(/[\r\n]+/g))
      setLoadingCSV(false)
      setShowLoadingModal(false)
    } catch {
      setOpenToast({
        open: true,
        message: 'Houve algum problema ao carregar CSV.',
        type: 'error'
      })
      setTimeout(history.goBack, 1500)
    }
  }

  const hideErrorsModal = () => setErrors(null)
  const showExcludeModal = () => setShouldExclude(true)
  const hideExcludeModal = () => setShouldExclude(false)

  const getPartners = query => {
    setPartnersInfo({ query })
    searchPartners(query)
  }

  const selectPartner = partner => {
    setPartnersInfo({
      showOptions: false,
      query: partner.fantasyName,
      chosen: partner
    })
    setDataIfPossible({
      partnerId: partner.id
    })
  }

  const setNewImage = async file => {
    if (!file) return
    console.log('file:', file)
    const imageURL = await ImageUploadToS3(file)

    setData(data => ({ ...data, cover: imageURL }))
    setImageName(file.name)
  }

  const setNewCodes = file => {
    if (!file) return

    if (!/\.csv$/.test(file.name))
      return setOpenToast({
        open: true,
        message: 'Arquivo selecionado inválido (somente CSV é válido).',
        type: 'error'
      })

    const fr = new FileReader()
    fr.onload = () => {
      const codesArray = fr.result.split(/[\r\n]+/g)
      const codes = codesArray.filter(code => code !== '')
      if (
        (CSV || []).every(code => !codes.includes(code)) &&
        codes.every(code1 => codes.filter(code2 => code1 === code2).length === 1)
      )
        return setDataIfPossible({
          newCodes: codes
        })

      setOpenToast({
        open: true,
        message: 'Arquivo selecionado contém códigos repetidos.',
        type: 'error'
      })
    }
    fr.readAsText(file)
  }

  const checkErrors = () => {
    const errors = []
    // partner
    if (!data.partnerId) errors.push('Sem parceiro')
    // value
    if (data.value === 0) errors.push('Valor final precisa ser maior que zero')
    // fullValue
    if (data.fullValue === 0) errors.push('Valor cheio precisa ser maior que zero')
    // rules
    if (!stripHtml(data.rules.toString('html')).trim()) errors.push('Sem regras de uso')
    // room type
    if (!data.roomType) errors.push('Sem tipo de sala')
    // movie type
    if (!data.movieType) errors.push('Sem tipo de filme')
    // new codes
    if (!itemToEdit && data.newCodes.length === 0) errors.push('Sem lista de códigos')
    // dates
    if (
      [
        data.sunday,
        data.monday,
        data.tuesday,
        data.wednesday,
        data.thursday,
        data.friday,
        data.saturday
      ].every(day => !day)
    )
      errors.push('Nenhum dia selecionado')

    return !!errors.length && errors
  }

  const uploadNewCodes = async () => {
    const finalData = [...(CSV || []), ...data.newCodes].join('\n')
    const fileName = (itemToEdit?.csv?.match(/[^\/]*?$/) || [])[0] || `${uuid.v4()}.csv`
    const { path } = await CreateFileS3({
      data: finalData,
      fileName,
      path: 'movieTickets/csv',
      contentType: 'text/csv',
      bucket: REACT_APP_BUCKET
    })
    return REACT_APP_IMAGES_URL + path
  }

  const save = async situation => {
    const errors = checkErrors()
    if (errors) {
      setErrors(errors)
      return
    }

    setLoading(true)
    setShowLoadingModal(true)

    const rules = data.rules.toString('html')
    const csv = data.newCodes?.length > 0 ? await uploadNewCodes() : data.csv

    await addOrEditMovieTickets({
      ...data,
      situation,
      rules,
      csv
    })

    setLoading(false)
    setShowLoadingModal(false)

    history.push('/movieticketslist')
  }

  const publish = () => save(1)
  const saveAsDraft = () => save(3)

  const exclude = async () => {
    setLoading(true)
    setShowLoadingModal(true)

    await addOrEditMovieTickets({
      id: data.id,
      situation: 2
    })

    setLoading(false)
    setShowLoadingModal(false)

    history.push('/movieticketslist')
  }

  const toolbarConfig = {
    display: ['INLINE_STYLE_BUTTONS', 'BLOCK_TYPE_BUTTONS', 'LINK_BUTTONS'],
    INLINE_STYLE_BUTTONS: [
      { label: 'Bold', style: 'BOLD' },
      { label: 'Italic', style: 'ITALIC' }
    ],
    BLOCK_TYPE_BUTTONS: [
      { label: 'UL', style: 'unordered-list-item' },
      { label: 'OL', style: 'ordered-list-item' }
    ]
  }

  const handleAdditional = e => {
    setAdditional(e)
    setDataIfPossible({
      movieType: e
    })
  }

  return (
    <>
      <div className={classes.outerContainer}>
        {loading || loadingCSV ? <LinearProgress /> : null}
        <div className={classes.content}>
          <div className={classes.main}>
            <div className={clsx(classes.inputGroup, classes.fullRowTwoColumns)}>
              <span>Parceiro</span>
              <input
                value={partners.query}
                onFocus={() => setPartnersInfo({ showOptions: true })}
                onChange={e => getPartners(e.target.value)}
                disabled={itemToEdit}
              />
              {partners.showOptions && (
                <MenuList className={classes.menuList}>
                  {partners.loading && <MenuItem disabled>Pesquisando...</MenuItem>}
                  {!partners.loading && partners.data.length === 0 && (
                    <MenuItem disabled>
                      {partners.query.trim().length < 4
                        ? 'Pesquise um termo'
                        : 'Nenhum resultado encontrado'}
                    </MenuItem>
                  )}
                  {partners.data.map(partner => (
                    <MenuItem key={partner.id} onClick={() => selectPartner(partner)}>
                      {partner.fantasyName}
                    </MenuItem>
                  ))}
                </MenuList>
              )}
            </div>
            <div className={classes.inputGroup}>
              <span>Valor cheio do ingresso</span>
              <input
                value={new Intl.NumberFormat('pt-br', {
                  style: 'currency',
                  currencyDisplay: 'symbol',
                  currency: 'BRL',
                  maximumFractionDigits: 2,
                  minimumFractionDigits: 2
                }).format(data.fullValue)}
                onChange={e =>
                  setDataIfPossible({
                    fullValue: Number(e.target.value.replace(/\D/g, '')) / 100
                  })
                }
              />
            </div>
            <div className={classes.inputGroup}>
              <span>Valor final do ingresso</span>
              <input
                value={new Intl.NumberFormat('pt-br', {
                  style: 'currency',
                  currencyDisplay: 'symbol',
                  currency: 'BRL',
                  maximumFractionDigits: 2,
                  minimumFractionDigits: 2
                }).format(data.value)}
                onChange={e =>
                  setDataIfPossible({
                    value: Number(e.target.value.replace(/\D/g, '')) / 100
                  })
                }
              />
            </div>
            <div className={classes.inputGroup}>
              <span>Valor de compra</span>
              <input
                value={new Intl.NumberFormat('pt-br', {
                  style: 'currency',
                  currencyDisplay: 'symbol',
                  currency: 'BRL',
                  maximumFractionDigits: 2,
                  minimumFractionDigits: 2
                }).format(data.purchasePrice)}
                onChange={e =>
                  setDataIfPossible({
                    purchasePrice: Number(e.target.value.replace(/\D/g, '')) / 100
                  })
                }
              />
            </div>
            <div className={classes.inputGroup}>
              <span>Tipo de filme</span>
              <select value={data.movieType} onChange={e => handleAdditional(e.target.value)}>
                <option disabled value="" />
                <option value="2D">2D</option>
                <option value="3D">3D</option>
                <option value="2D ou 3D">2D ou 3D</option>
                <option value="Adicionais">Combo</option>
              </select>
            </div>
            <div className={classes.inputGroup}>
              <span>Tipo</span>
              {additional === 'Adicionais' ? (
                <select
                  value={data.roomType}
                  onChange={e =>
                    setDataIfPossible({
                      roomType: e.target.value
                    })
                  }
                >
                  <option disabled value="" />

                  <option value="others">Outros</option>
                </select>
              ) : (
                <select
                  value={data.roomType}
                  onChange={e =>
                    setDataIfPossible({
                      roomType: e.target.value
                    })
                  }
                >
                  <option disabled value="" />
                  <option value="films">Filmes</option>
                </select>
              )}
            </div>
            {additional === 'Adicionais' && (
              <div className={classes.inputGroup}>
                <span>Capa do combo</span>
                <div>
                  <input value={`${imageName || '' || data.cover}`} readOnly />
                  <span className={classes.spacer} />
                  <label>
                    <span className={classes.plainButton2}>Selecionar arquivo</span>

                    <input
                      className={classes.hiddenInput}
                      type="file"
                      accept="image/*"
                      onChange={e => setNewImage(e.target.files[0])}
                    />
                  </label>
                </div>
              </div>
            )}
            <div className={clsx(classes.inputGroup, classes.fullRowTwoColumns)}>
              {additional === 'Adicionais' ? (
                <>
                  <span>Título do voucher</span>
                  <input
                    value={data.complement}
                    onChange={e =>
                      setDataIfPossible({
                        complement: e.target.value
                      })
                    }
                    placeholder="Kit pipoca ..."
                  />
                </>
              ) : (
                <>
                  <span>Título do voucher</span>
                  <input
                    style={{ marginBottom: '20px' }}
                    value={data.complement}
                    onChange={e =>
                      setDataIfPossible({
                        complement: e.target.value
                      })
                    }
                    placeholder="Voucher 2D..."
                  />
                  {/* <span>Nome da sala</span>
                  <input
                    value={data.room}
                    onChange={e =>
                      setDataIfPossible({
                        room: e.target.value,
                      })
                    }
                    placeholder="e.g. 4D Max"
                  /> */}
                </>
              )}
            </div>

            <div className={clsx(classes.inputGroup, classes.fullRowTwoColumns)}>
              <span>Slug</span>
              <input
                value={data.slug}
                onChange={e => {
                  // console.log(e.target.value.replace(/ /g, '-'));
                  setData({
                    ...data,
                    slug: e.target.value.replace(/ /g, '-')
                  })
                }}
                placeholder="Slug ..."
              />
            </div>
            <div className={classes.inputGroup}>
              <span>Upload de CSV</span>
              <div>
                {data.newCodes.length > 0 && (
                  <input value={`${data.newCodes.length} código(s)`} readOnly />
                )}
                <span className={classes.spacer} />
                <label>
                  <span className={classes.plainButton2}>Selecionar arquivo</span>
                  <input
                    className={classes.hiddenInput}
                    type="file"
                    accept="text/csv"
                    onChange={e => setNewCodes(e.target.files[0])}
                  />
                </label>
              </div>
            </div>
            <div className={clsx(classes.inputGroup, classes.dateInputGroup)}>
              <span>Data de validade</span>
              <MuiPickersUtilsProvider libInstance={moment} utils={MomentUtils} locale="pt-br">
                <DatePicker
                  format="L"
                  value={data.validDate}
                  onChange={mmt =>
                    setDataIfPossible({
                      validDate: mmt.format('YYYY-MM-DD')
                    })
                  }
                  minDate={itemToEdit?.validDate || moment().add(1, 'day').format('YYYY-MM-DD')}
                />
              </MuiPickersUtilsProvider>
            </div>
            <div className={clsx(classes.inputGroup, classes.fullRowTwoColumns)}>
              <span>Dias da semana</span>
              <div style={{ height: 'unset', justifyContent: 'space-evenly' }}>
                {[
                  ['Domingo', 'sunday'],
                  ['Segunda-feira', 'monday'],
                  ['Terça-feira', 'tuesday'],
                  ['Quarta-feira', 'wednesday'],
                  ['Quinta-feira', 'thursday'],
                  ['Sexta-feira', 'friday'],
                  ['Sábado', 'saturday']
                ].map(([label, prop]) => (
                  <FormControlLabel
                    className={classes.checkboxLabel}
                    checked={!!data[prop]}
                    onChange={e =>
                      setDataIfPossible({
                        [prop]: Number(e.target.checked)
                      })
                    }
                    control={<Checkbox className={clsx(classes.checkbox)} />}
                    label={label}
                    labelPlacement="bottom"
                  />
                ))}
              </div>
            </div>
            <div className={clsx(classes.inputGroup, classes.fullRowTwoColumns)}>
              <span>Regras de uso</span>
              <div style={{ height: 'unset' }}>
                <RTE
                  className={classes.rte}
                  value={data.rules}
                  onChange={value =>
                    setDataIfPossible({
                      rules: value
                    })
                  }
                  toolbarConfig={toolbarConfig}
                />
              </div>
            </div>
          </div>
          <div className={classes.aside}>
            <div className={clsx(classes.link, classes.fullRowTwoColumns)}>
              <a
                href="https://docs.google.com/spreadsheets/d/1ZTnot0TVZgbTCBVAtZAj-JgkEgYWX2zhS4aH9a106gY/edit?usp=sharing"
                target="_blank"
                rel="noreferrer noopener"
              >
                Ver modelo .CSV
              </a>
            </div>
            {itemToEdit && (
              <button
                className={clsx(classes.plainButton, classes.plainButtonRed)}
                type="button"
                onClick={showExcludeModal}
              >
                Suspender cupom
              </button>
            )}
            {!itemToEdit && (
              <button
                className={clsx(classes.plainButton, classes.plainButtonLilac)}
                type="button"
                onClick={saveAsDraft}
              >
                Salvar rascunho
              </button>
            )}
            <button className={classes.shadowButton} type="button" onClick={publish}>
              {itemToEdit?.situation === 1 ? 'Salvar' : 'Publicar'}
            </button>
            {itemToEdit?.situation === 3 && (
              <button
                className={clsx(classes.plainButton, classes.plainButtonLilac)}
                type="button"
                onClick={saveAsDraft}
              >
                Salvar rascunho
              </button>
            )}
          </div>
        </div>
      </div>

      <Dialog
        open={!!errors}
        onClose={hideErrorsModal}
        transitionDuration={{ enter: 250, exit: 0 }}
      >
        <DialogTitle>Erros encontrados</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Encontramos os seguintes erros:
            <ul>
              {errors?.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
            Corrija-os antes de prosseguir.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button color="primary" onClick={hideErrorsModal}>
            Ok
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={shouldExclude} onClose={hideExcludeModal}>
        <DialogTitle>Excluir</DialogTitle>
        <DialogContent>
          <DialogContentText>Deseja suspender o grupo de ingressos?</DialogContentText>
          <DialogContentText>A ação não pode ser desfeita.</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button color="primary" onClick={hideExcludeModal}>
            Não
          </Button>
          <Button color="primary" onClick={exclude}>
            Sim
          </Button>
        </DialogActions>
      </Dialog>

      <ToastMessages />
    </>
  )
}

const useStyles = makeStyles({
  outerContainer: {
    display: 'flex',
    flexDirection: 'column',
    fontFamily: 'Montserrat',
    fontWeight: '500',
    '& label': {
      margin: '0 !important'
    }
  },
  content: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    padding: '45px'
  },
  main: {
    flexGrow: 1,
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    marginRight: 30,
    gap: '30px'
  },
  group: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    alignItems: 'end',
    padding: '30px',
    gap: '20px 30px',
    backgroundColor: '#ece5fe',
    borderRadius: '4px'
  },
  inputGroup: {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    '& > span': {
      fontSize: '16px',
      fontWeight: 700,
      color: '#30287b'
    },
    '& > input, & > div, & textarea, & select': {
      marginTop: '10px',
      background: '#fff',
      border: '2px solid #30287b !important',
      '&[disabled]': {
        opacity: 1,
        background: '#0000000a'
      }
    },
    '& input, & textarea, & select': {
      padding: '11px 13px',
      fontSize: '14px',
      color: '#30287b',
      border: 'none'
    },
    '& > div': {
      display: 'flex',
      flexDirection: 'row'
    },
    '& > div input, & > div select': {
      flexGrow: 1,
      height: '100%'
    },
    '& > input, & > div, & select': {
      height: 44
    },
    '& textarea': {
      minHeight: 132,
      resize: 'none'
    }
  },
  dateInputGroup: {
    width: '100%',
    '& *::before': {
      display: 'none !important'
    },
    '& *::after': {
      display: 'none !important'
    }
  },
  divider: {
    marginTop: '15px',
    borderBottom: '2px solid #b294ff'
  },
  divider2: {
    margin: '10px -30px',
    borderBottom: '2px solid #b294ff'
  },
  subtitle: {
    margin: '15px 0 0',
    fontFamily: 'Matrice',
    fontSize: '18px',
    color: '#30287b'
  },
  aside: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, auto)',
    width: '30%',
    minWidth: 340,
    gap: '15px'
  },
  fullRowTwoColumns: {
    gridColumn: '1 / 3'
  },
  box: {
    border: '2px solid #30287b',
    '& h4': {
      marginBottom: 0,
      fontSize: '14px',
      fontWeight: '700',
      color: '#ffffff',
      lineHeight: '44px',
      textAlign: 'center',
      textTransform: 'uppercase',
      background: '#30287b',
      borderBottom: '2px solid #30287b'
    },
    '& > div': {
      display: 'grid',
      gridTemplateColumns: 'auto',
      gap: '15px',
      padding: '30px'
    }
  },
  plainButton: {
    display: 'block',
    width: '100%',
    margin: '0',
    padding: '0 20px',
    fontSize: '12px',
    fontWeight: '700',
    color: '#30287b',
    lineHeight: '44px',
    textAlign: 'center',
    textTransform: 'uppercase',
    background: '#ece5fe',
    border: 'none',
    borderRadius: '2px',
    cursor: 'pointer'
  },
  plainButton2: {
    display: 'block',
    margin: '2px',
    padding: '6px 5px',
    fontSize: '11px',
    fontWeight: '700',
    color: '#30287b',
    lineHeight: '24px',
    textAlign: 'center',
    textTransform: 'uppercase',
    background: '#ece5fe',
    border: 'none',
    borderRadius: '2px',
    cursor: 'pointer'
  },
  plainButtonRed: {
    color: '#fff',
    background: '#d73f32'
  },
  plainButtonLilac: {
    color: '#30287b',
    background: '#ece5fe'
  },
  shadowButton: {
    width: '100%',
    fontSize: '12px',
    fontWeight: '700',
    color: '#30287b',
    lineHeight: '44px',
    textAlign: 'center',
    textTransform: 'uppercase',
    background: '#fbbb33',
    border: 'none',
    borderRadius: '2px',
    boxShadow: '4px 4px #4200f5',
    cursor: 'pointer'
  },
  img: {
    width: '100%',
    height: 'auto'
  },
  hiddenInput: {
    visibility: 'hidden',
    opacity: 0,
    position: 'absolute',
    width: 0,
    height: 0,
    margin: 0,
    padding: 0
  },
  legend: {
    fontSize: '12px',
    fontStyle: 'italic',
    color: '#30287b',
    textAlign: 'center'
  },
  end: {
    justifySelf: 'end',
    width: 'fit-content'
  },
  addButton: {
    justifySelf: 'center',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '11px 15px',
    fontSize: '12px',
    fontWeight: 700,
    color: '#30287b',
    lineHeight: '15px',
    textTransform: 'uppercase',
    border: '2px solid #30287b',
    borderRadius: 4,
    cursor: 'pointer',
    '& svg': {
      marginRight: '6px',
      fontSize: '18px'
    }
  },
  menuList: {
    position: 'absolute',
    width: '100%',
    top: '100%',
    left: 0,
    background: '#ece5fe',
    zIndex: 10
  },
  link: {
    fontSize: '14px',
    fontWeight: '700',
    color: '#30287b',
    lineHeight: '44px',
    textAlign: 'center',
    background: '#ece5fe',
    '& a': {
      color: 'inherit'
    }
  },
  rte: {
    width: '100%',
    minHeight: 140,
    border: 'none'
  },
  checkboxLabel: {
    color: '#30287b'
  },
  checkbox: {
    color: '#30287b !important'
  },
  spacer: {
    flexGrow: 1
  }
})

export default MovieTicketsForm
